<template>
  <div class="config-order-page">
    <div class="page-scroll">
      <!-- 电影信息卡片 -->
      <div class="order-card movie-card">
        <!-- 影院信息区域 - 与影院列表样式一致 -->
        <div class="cinema-info-block">
          <div class="cinema-name-main">{{ movieData?.cinemaName }}</div>
          <div class="cinema-addr-row">
            <van-icon name="location-o" size="0.9rem" color="#999" />
            <span>{{ movieData?.cinemaAddress || '暂无地址' }}</span>
          </div>
        </div>
        <!-- 分隔线 -->
        <div class="info-divider"></div>
        <!-- 影片信息 -->
        <div class="movie-info">
          <img :src="movieData?.moviePicUrl" alt="" class="movie-poster" />
          <div class="movie-details">
            <div class="movie-name">{{ movieData?.movieName }}</div>
            <div class="movie-time-row">
              <span class="play-time">{{ movieData?.moviePlayTime }}</span>
              <span class="hall-type-tag">{{ movieData?.hallType }}</span>
            </div>
            <div class="hall-name">{{ movieData?.hallName }}</div>
            <!-- 座位信息 -->
            <div class="seat-info-inline">
              <van-icon name="coupon-o" size="0.85rem" color="#ee0a24" />
              <span class="seat-value">{{ seatNames }}</span>
            </div>
          </div>
        </div>
        <div class="policy-row">
          <div class="policy-tags">
            <van-icon name="clear" color="#ee0a24" />
            <span>不支持退款</span>
            <van-icon name="clear" color="#ee0a24" class="ml-10" />
            <span>不支持改签</span>
          </div>
          <div class="agreement-link" @click="showTags">
            购票协议<van-icon name="arrow" />
          </div>
        </div>
      </div>

      <!-- 手机号信息卡片 -->
      <div class="order-card">
        <div class="phone-title">手机号：{{ displayPhone }}</div>
        <div class="tip-row">
          <van-icon name="warning-o" color="#faad14" />
          <span class="tip-label">特别提示</span>
        </div>
        <div class="tip-content">
          当前手机号仅作为下单使用，将不再接收验票码，您可在详情页中查看验票码。
        </div>
      </div>

      <!-- 价格信息卡片 -->
      <div class="order-card">
        <div class="price-row">
          <span>合计应付</span>
          <span class="price-highlight">{{ form?.productTotal }}点</span>
        </div>
        <div class="price-row mt-10">
          <span class="price-label">商品合计</span>
          <span class="price-value">{{ form?.productTotal }}点</span>
        </div>
      </div>

      <!-- 购票须知卡片 -->
      <div class="order-card notice-card">
        <div class="notice-title">购票须知:</div>
        <div class="notice-item">1.请确认场次和时间无误，购买成功后将不可退票、不可改签；</div>
        <div class="notice-item">2.由于设备故障等不可抗力因素，存在少量场次取消的情况，我们将及时为您退票退款，支付金额将原路退还；</div>
        <div class="notice-item">3.由于影院系统不稳定等原因，可能存在出票失败的情况，我们将及时为您退票退款，支付金额将原路退还；</div>
        <div class="notice-item">4.订单支付成功并出票后，验票信息请在"我的-全部订单-订单详情"中查看。</div>
      </div>
    </div>

    <!-- 底部提交栏 -->
    <div class="submit-bar">
      <div class="total-price">
        实付款：
        <span class="price-amount">{{ form?.productTotal }}</span>
        <span class="price-unit">点</span>
      </div>
      <div 
        class="submit-btn" 
        :class="{ 'btn-disabled': isPreviewMode || disabledSub }"
        @click="handleSubmit">
        提交订单
      </div>
    </div>

    <get-know v-if="showtag" @closed="closeds" :checkT="checkTag"></get-know>
  </div>
</template>

<script>
import { Toast } from "vant";
import GetKnow from '../../components/movie/GetKnow'

export default {
  name: 'ConfigOrder',
  components: { GetKnow },
  data() {
    return {
      form: null,
      movieData: null,
      LoginPhone: '',
      showtag: false,
      checkTag: false,
      disabledSub: false,
      seatNames: '',
    }
  },
  computed: {
    isPreviewMode() {
      return localStorage.getItem('isPreviewMode') === 'true';
    },
    displayPhone() {
      if (this.isPreviewMode) {
        return '预览不支持手机号';
      }
      return this.LoginPhone || '';
    },
  },
  mounted() {
    this.form = JSON.parse(localStorage.getItem('lockseatform'))
    this.movieData = JSON.parse(this.form.orderDetail)
    this.seatNames = this.movieData?.seatNames.slice(0, this.movieData?.seatNames.length - 1)
    this.LoginPhone = localStorage.getItem('loginphone')
  },
  methods: {
    closeds(val) {
      this.checkTag = val
      this.showtag = false
      if (val) {
        this.lockseat()
      }
    },
    showDialog() {
      this.$Dialog.confirm({
        title: "提示",
        message: "您有订单未支付，请先支付后再下单",
        confirmButtonText: '去查看',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$router.push({
            path: "/AllOrder",
            query: { active: 1 },
          });
        })
        .catch(() => {});
    },
    showTags() {
      this.showtag = true
    },
    handleSubmit() {
      if (this.isPreviewMode) {
        Toast("预览模式不支持下单");
        return;
      }
      if (this.disabledSub) return;
      this.lockseat();
    },
    lockseat() {
      this.disabledSub = true
      if (!this.checkTag) {
        this.showtag = true
        this.disabledSub = false
        return
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.$api
        .lockOrder(this.form)
        .then((res) => {
          Toast.clear();
          if (res.code == 1) {
            if (res.data == 1) {
              this.showDialog()
            } else {
              this.$Toast(res.msg, 5);
            }
          } else {
            let orderId = res.data.qmmOrderId
            if (orderId) {
              this.toPay(res.data.orderNo)
            } else {
              this.$Toast(res.msg, 5);
            }
          }
          this.disabledSub = false
        })
        .catch((err) => {
          this.disabledSub = false
          Toast.clear();
        });
    },
    toPay(orderNo) {
      // 统一跳转到统一支付页面
      this.$router.push({
        path: '/UnifiedCashier',
        query: {
          orderNo: orderNo,
        },
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.config-order-page {
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 4rem;
}

/* 订单卡片 */
.order-card {
  margin: 0.8rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 电影信息卡片特殊样式 */
.movie-card {
  padding-bottom: 0.8rem;
}

/* 影院信息区域 - 与影院列表样式一致 */
.cinema-info-block {
  margin-bottom: 0.8rem;
}

.cinema-name-main {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin-bottom: 0.4rem;
  word-break: break-word;
}

.cinema-addr-row {
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  font-size: 0.85rem;
  color: #999;
  line-height: 1.5;
  
  span {
    word-break: break-word;
  }
  
  .van-icon {
    flex-shrink: 0;
    margin-top: 0.15rem;
  }
}

.info-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0.8rem 0;
}

/* 电影信息 */
.movie-info {
  display: flex;
  gap: 0.8rem;
}

.movie-poster {
  width: 5.5rem;
  height: 7.5rem;
  border-radius: 0.5rem;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.movie-details {
  flex: 1;
  min-width: 0;
}

.movie-name {
  font-size: 1.15rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.4rem;
  line-height: 1.3;
}

.movie-time-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}

.play-time {
  font-size: 0.95rem;
  font-weight: 600;
  color: #ee0a24;
}

.hall-type-tag {
  display: inline-block;
  padding: 0.1rem 0.4rem;
  background: linear-gradient(135deg, #ff6b4a 0%, #ee0a24 100%);
  color: #fff;
  font-size: 0.7rem;
  border-radius: 0.2rem;
  font-weight: 500;
}

.cinema-name {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.2rem;
}

.hall-name {
  font-size: 0.85rem;
  color: #999;
}

/* 座位信息高亮框 */
.seat-info-box {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.8rem;
  padding: 0.6rem 0.8rem;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0ed 100%);
  border-radius: 0.4rem;
  border: 1px solid #ffebe8;
}

.seat-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ee0a24;
}

/* 行内座位信息样式 */
.seat-info-inline {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-top: 0.5rem;
  padding: 0.4rem 0.6rem;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0ed 100%);
  border-radius: 0.3rem;
  border: 1px solid #ffebe8;
  
  .seat-value {
    font-size: 0.8rem;
    font-weight: 600;
    color: #ee0a24;
  }
}

/* 政策行 */
.policy-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 1px solid #f0f0f0;
}

.policy-tags {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #333;
  
  .ml-10 {
    margin-left: 0.5rem;
  }
}

.agreement-link {
  font-size: 0.85rem;
  color: #999;
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* 手机号卡片 */
.phone-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.6rem;
}

.tip-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
}

.tip-label {
  color: #faad14;
  font-size: 0.9rem;
  font-weight: 500;
}

.tip-content {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
}

/* 价格卡片 */
.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  
  &.mt-10 {
    margin-top: 0.5rem;
  }
}

.price-highlight {
  color: #ee0a24;
  font-weight: 600;
  font-size: 1.05rem;
}

.price-label {
  font-weight: 600;
  color: #333;
}

.price-value {
  color: #333;
}

/* 购票须知 */
.notice-card {
  margin-bottom: 4rem;
}

.notice-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.notice-item {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.3rem;
}

/* 底部提交栏 */
.submit-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 1rem;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  z-index: 100;
}

.total-price {
  font-size: 0.95rem;
  color: #333;
  display: flex;
  align-items: baseline;
}

.price-amount {
  font-size: 1.3rem;
  font-weight: 600;
  color: #ee0a24;
  margin-left: 0.2rem;
}

.price-unit {
  font-size: 0.85rem;
  color: #ee0a24;
  margin-left: 0.1rem;
}

.submit-btn {
  padding: 0.6rem 1.8rem;
  background: linear-gradient(135deg, #ee0a24 0%, #ff6b4a 100%);
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
  
  &.btn-disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>